module.exports = __webpack_public_path__ + "static/media/Icono empresa.bcd2ebb1.svg";